<template>
  <div v-if="messageRepied">[Danh thiếp] {{ content.title }}</div>
  <div
    v-else
    class="d-flex flex-column py-2 bg-blue500 rounded"
    style="min-width: 230px">
    <div class="d-flex mb-2 px-3">
      <div class="d-flex flex-column align-items-center justify-content-evenly">
        <el-avatar
          class="mt-1 border-white"
          :src="content.thumb" />
        <div
          class="fw-500 font-13 text-center text-2-line text-white"
          style="max-width: 100px">
          {{ content.title }}
        </div>
      </div>
      <div class="flex-1"></div>
      <div class="d-flex flex-column align-items-center align-self-center">
        <el-popover
          v-if="contentDescription.qrCodeUrl"
          placement="top"
          width="300"
          trigger="click">
          <el-image
            class="align-self-center"
            :src="contentDescription.qrCodeUrl"
            style="margin-left: auto; max-width: 300px; max-height: 300px" />
          <el-image
            slot="reference"
            class="pointer"
            :src="contentDescription.qrCodeUrl"
            style="margin-left: auto; max-width: 70px; max-height: 70px; border-radius: 3px" />
        </el-popover>
        <div
          v-if="contentDescription.phone"
          class="font-13 fw-400 d-flex align-items-center"
          style="color: #e1edfd">
          {{ contentDescription.phone }}
          <ButtonCopy
            class="ms-1"
            :valueCopy="contentDescription.phone"
            color="#E1EDFD" />
        </div>
      </div>
    </div>
    <el-popover
      placement="bottom"
      width="300"
      trigger="click">
      <el-input
        type="textarea"
        placeholder="Nhập nội dung tin nhắn"
        :row="2"
        v-model="messageText"></el-input>
      <div class="d-flex justify-content-end">
        <el-button
          type="primary"
          size="mini"
          class="mt-2"
          @click="sendMessage()">
          Gửi
        </el-button>
      </div>
      <div
        slot="reference"
        @click="showPopupMessage = true"
        style="margin-bottom: -0.5rem"
        class="pointer py-2 d-flex align-items-center justify-content-center font-13 text-white bg-blue400 rounded-bottom">
        Nhắn tin
      </div>
    </el-popover>
  </div>
</template>

<script>
import ButtonCopy from "../common/ButtonCopy.vue";

export default {
  components: { ButtonCopy },
  name: "ChatBusinessCard",
  props: ["message", "accountId", "messageRepied"],
  data() {
    return {
      showPopupMessage: false,
      messageText: "",
    };
  },
  computed: {
    content() {
      return JSON.parse(this.message.content);
    },
    contentDescription() {
      try {
        return JSON.parse(this.content.description);
      } catch {
        return {};
      }
    },
  },
  methods: {
    sendMessage() {
      if (!this.messageText) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }

      let request = {
        accountId: this.accountId,
        toId: this.content.params,
        message: this.messageText,
      };
      this.$http.post("/api/message/sms", request).then(() => {
        this.messageText = "";
        this.showPopupMessage = false;
        this.alert("success", "Đã gửi tin nhắn");
      });
    },
  },
};
</script>

<style scoped>
.border-white {
  border: 3px solid white !important;
}
</style>